// Run cb when the browser is idle, falling back to a timer on engines without
// requestIdleCallback (jsdom, older Safari). fallbackMs is the setTimeout delay used
// in that case; timeout (optional) is passed to requestIdleCallback so the work still
// runs if the browser never goes idle. Centralizes the three hand-rolled shims (scent
// layer, find-refs enhancement, chunked verse fill).
export function onIdle(cb: () => void, fallbackMs: number, timeout?: number): void {
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(() => cb(), timeout != null ? { timeout } : undefined);
  } else {
    setTimeout(cb, fallbackMs);
  }
}
